// Division utility functions for skill-based division system

// Skill level ranges and their corresponding division names
export const SKILL_LEVEL_DIVISIONS = {
  '1.0-2.5': {
    name: 'Beginner',
    min: 1.0,
    max: 2.5,
    description: 'Perfect for new players learning the fundamentals'
  },
  '3.0-3.5': {
    name: 'Beginner +',
    min: 3.0,
    max: 3.5,
    description: 'Players with basic skills and some match experience'
  },
  '4.0-4.5': {
    name: 'Intermediate',
    min: 4.0,
    max: 4.5,
    description: 'Players with solid fundamental skills'
  },
  '5.0-5.5': {
    name: 'Intermediate +',
    min: 5.0,
    max: 5.5,
    description: 'Experienced players with advanced techniques'
  },
  '6.0-6.5': {
    name: 'Advanced',
    min: 6.0,
    max: 6.5,
    description: 'Highly skilled players with tournament experience'
  },
  '7.0-7.5': {
    name: 'Advanced +',
    min: 7.0,
    max: 7.5,
    description: 'Expert players with competitive background'
  },
  '8.0-10.0': {
    name: 'Elite',
    min: 8.0,
    max: 10.0,
    description: 'Professional-level players and champions'
  }
};

// Function to get division name from skill level
export const getDivisionNameFromSkillLevel = (skillLevel) => {
  const level = parseFloat(skillLevel);
  
  for (const [range, division] of Object.entries(SKILL_LEVEL_DIVISIONS)) {
    if (level >= division.min && level <= division.max) {
      return division.name;
    }
  }
  
  return 'Unknown';
};

// Function to get division info from skill level
export const getDivisionInfoFromSkillLevel = (skillLevel) => {
  const level = parseFloat(skillLevel);
  
  for (const [range, division] of Object.entries(SKILL_LEVEL_DIVISIONS)) {
    if (level >= division.min && level <= division.max) {
      return {
        ...division,
        range: range
      };
    }
  }
  
  return null;
};

// Function to get skill level range from division name
export const getSkillRangeFromDivisionName = (divisionName) => {
  for (const [range, division] of Object.entries(SKILL_LEVEL_DIVISIONS)) {
    if (division.name === divisionName) {
      return {
        min: division.min,
        max: division.max,
        range: range
      };
    }
  }
  
  return null;
};

// Function to generate all division names for dropdowns/selects
export const getAllDivisionNames = () => {
  return Object.values(SKILL_LEVEL_DIVISIONS).map(division => division.name);
};

// Function to generate all division ranges for dropdowns/selects
export const getAllDivisionRanges = () => {
  return Object.keys(SKILL_LEVEL_DIVISIONS);
};

// Function to format division display name with skill range
export const formatDivisionDisplayName = (divisionName, canton = '') => {
  const range = getSkillRangeFromDivisionName(divisionName);
  if (range) {
    return canton ? `${canton} ${divisionName} (${range.range})` : `${divisionName} (${range.range})`;
  }
  return canton ? `${canton} ${divisionName}` : divisionName;
};

// Function to check if a skill level is valid
export const isValidSkillLevel = (skillLevel) => {
  const level = parseFloat(skillLevel);
  return level >= 1.0 && level <= 10.0;
};
